import { CREDIT_CARD_TYPE } from "@icoach/constants/";
import { CARDFIELDMAP } from "./creditCard.config";

/**
  * 根據信用卡前幾碼判斷卡別
  * @param {string} cardNumber - 使用者輸入的卡號字串（可只輸入前 6 碼）
  * @returns {number} - 信用卡類型（CREDIT_CARD_TYPE）
  */
const detectCardType = cardNumber => {
	const cleaned = cardNumber.replace(/[\s\-*]/g, ""); // 去除空格與破折號 //*
	if (/^4\d{0,15}$/.test(cleaned)) return CREDIT_CARD_TYPE.VISA;
	if (/^5[1-5]\d{0,14}$/.test(cleaned)) return CREDIT_CARD_TYPE.MasterCard;
	if (/^2(2[2-9][1-9]|2[3-9]\d{2}|[3-6]\d{3}|7[01]\d{2}|720)\d*$/.test(cleaned)) return CREDIT_CARD_TYPE.MasterCard;
	if (/^35(2[89]|[3-8]\d)\d*$/.test(cleaned)) return CREDIT_CARD_TYPE.JCB;
	// if (/^3[47]\d{0,13}$/.test(cleaned)) return "American Express";
	// if (/^6(?:011|5\d{2}|4[4-9]\d)\d*$/.test(cleaned)) return "Discover";
	// if (/^3(?:0[0-5]|[68]\d)\d*$/.test(cleaned)) return "Diners Club";
	return CREDIT_CARD_TYPE.OTHER;
};

/**
 * 根據提供的欄位列表與預設值建立初始的信用卡資料物件。
 *
 * 此函式會遍歷 `fields` 陣列中的每個欄位名稱：
 * - 如果欄位為 `"creditCardType"`，則使用預設的 `creditCardType` 值，
 *   若無則預設為 `CREDIT_CARD_TYPE.VISA`。
 * - 其他欄位則設為對應的 `defaultValue[key]`，若無則為空字串。
 *
 * @param {Object} [defaultValue={}] - 預設值物件，包含初始欄位資料。
 * @param {string[]} [fields=[]] - 欲建立的欄位名稱列表。
 * @returns {Object} 初始欄位資料物件。
 *
 * @example
 * const fields = ['cardNumber', 'creditCardType', 'cardHolder'];
 * const defaultValue = { creditCardType: 'MasterCard', cardHolder: 'Allen' };
 * const initial = getInitialCreditCardInfo(defaultValue, fields);
 * // 回傳: { cardNumber: '', creditCardType: 'MasterCard', cardHolder: 'Allen' }
 */
const getInitialCreditCardInfo = (
	defaultValue = {
		creditCardType: null,
		cardExpiryDate: null,
		creditCardBankName: null,
		creditCardNo: null,
	},
	fields = []
) => {
	const s = fields.reduce((InitialData, key) => {
		InitialData[key] = defaultValue?.[key] || "";
		return InitialData;
	}, {});
	if (s[CARDFIELDMAP.CARDNO]) s[CARDFIELDMAP.CARDTYPE] = defaultValue.creditCardType;
	return s;
};

export { detectCardType, getInitialCreditCardInfo };
